function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "36",
  height: "16",
  viewBox: "0 0 36 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M.137 7.735v6.932h7.1a6.988 6.988 0 006.99-6.988c0-3.86-3.158-6.989-7.017-6.989C3.319.69.137 3.844.137 7.735z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.036 4.577V2.269h5.41m5.41 2.308V2.269h-5.41m0 0v10.82m0 0h-2.287m2.287 0h2.308",
  stroke: "#fff",
  strokeWidth: "1.7",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));